webpackJsonp([10],{

/***/ 748:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_forgot_password_vue__ = __webpack_require__(791);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ccf9d0b2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_forgot_password_vue__ = __webpack_require__(840);
var normalizeComponent = __webpack_require__(105)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_forgot_password_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ccf9d0b2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_forgot_password_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 766:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.5ea00f2.png";

/***/ }),

/***/ 768:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__request__ = __webpack_require__(69);


var resource = 'auth';
var recoverPassword = function recoverPassword(email, type) {
  return __WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */].post(resource + '/recovery', { email: email, type: type });
};
var check_token = function check_token(token) {
  return __WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */].get(resource + '/reset/' + token);
};
var reset_password = function reset_password(data) {
  return __WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */].post(resource + '/reset', data);
};
var get_user_info = function get_user_info(data) {
  return __WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */].get(resource + '/user', data);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  recoverPassword: recoverPassword,
  check_token: check_token,
  reset_password: reset_password,
  get_user_info: get_user_info
});

/***/ }),

/***/ 791:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_auth__ = __webpack_require__(768);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      email: ''
    };
  },

  methods: {
    handleClickResetPassword: function handleClickResetPassword() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this.$validator.validateAll().then(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(res) {
                    var loading;
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (!res) {
                              _context.next = 13;
                              break;
                            }

                            loading = _this.$loading.show({ opacity: 0.5 });
                            _context.prev = 2;
                            _context.next = 5;
                            return __WEBPACK_IMPORTED_MODULE_2__api_auth__["a" /* default */].recoverPassword(_this.email, 'sns');

                          case 5:
                            _this.$message({ message: 'メールアドレス宛にパスワード再設定通知を送りました', type: 'success' });
                            _this.$router.push({ name: 'login' });
                            _context.next = 12;
                            break;

                          case 9:
                            _context.prev = 9;
                            _context.t0 = _context['catch'](2);

                            _this.$message({ message: '入力されたユーザーは存在しません', type: 'error' });

                          case 12:
                            loading.hide();

                          case 13:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this, [[2, 9]]);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    }
  }
});

/***/ }),

/***/ 840:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"forgot_password_page"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"page_title"},[_vm._v("\n    パスワード再設定\n  ")]),_vm._v(" "),_c('div',{staticClass:"forgot_password_form"},[_c('p',[_vm._v("\n      パスワード再設定用のURLを送るメールアドレスを入力してください。\n    ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"},{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],attrs:{"name":"form_email","type":"email","placeholder":"メールアドレス"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"vee-validate-message"},[_vm._v(_vm._s(_vm.errors.first('form_email')))]),_vm._v(" "),_c('a',{staticClass:"button deep_blue block mb-1 mt-6",attrs:{"href":"javascript:void(0)"},on:{"click":_vm.handleClickResetPassword}},[_vm._v("送信")]),_vm._v(" "),_c('router-link',{staticClass:"button silver block",attrs:{"to":{name: 'login'},"href":"javascript:void(0)"}},[_vm._v("キャンセル")])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page_header"},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":__webpack_require__(766),"alt":""}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/10.9cf740991b4ab68f947d.js